
import { MapLocation } from '@/types/location';

// Boost Gaming Center Locations
export const boostGamingCenters: MapLocation[] = [
  {
    id: 51001,
    name: "Boost Gaming Center - Jeddah (Al Zahraa)",
    type: "Game Center",
    devices: 7,
    coordinates: [21.584616865192565, 39.129267525140925],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
